import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface MeasurementUnit {
    active: number;
    createdAt: any;
    name: string;
    reference: string;
    symbol: string;
    type: string;
    updatedAt: any;
    value: number;
}

interface MeasurementUnitId extends MeasurementUnit {
    id: string;
}

@Injectable()
export class MeasurementUnitService {

    measurementUnitCollection: AngularFirestoreCollection<MeasurementUnit>;
    measurementUnits: any;

    measurementUnitDocument: AngularFirestoreDocument<MeasurementUnitId>;
    measurementUnit: Observable<MeasurementUnitId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.UNIT_COLLECTION;
    }

    postMeasurementUnit(measurementUnitObject: any) {
        this.measurementUnitCollection = this.afs.collection(this.collection);

        return this.measurementUnitCollection.add(measurementUnitObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    postMeasurementUnitWithId(measurementUnitObject: any, id$: string) {
        this.measurementUnitCollection = this.afs.collection(this.collection);

        return this.measurementUnitCollection.doc(id$).set(measurementUnitObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getMeasurementUnits() {
        this.measurementUnitCollection = this.afs.collection(this.collection, ref => ref.orderBy('name'));

        this.measurementUnits = this.measurementUnitCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as MeasurementUnit;

                const name = data.name;
                const reference = data.reference;
                const symbol = data.symbol;
                const type = data.type;
                const value = data.value;

                return { id$, name, reference, symbol, type, value };
            });
        }).map(object => object);

        return this.measurementUnits;
    }

    getMeasurementUnit(id$: string) {
        this.measurementUnitDocument = this.afs.doc(this.collection + '/' + id$);

        this.measurementUnit = this.measurementUnitDocument.valueChanges();

        return this.measurementUnit.map(object => object);
    }

    putMeasurementUnit(measurementUnitObject: any, id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.measurementUnitCollection = this.afs.collection(this.collection);

        return this.measurementUnitCollection.doc(id$).update(measurementUnitObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delMeasurementUnit(id$: string) {
        this.measurementUnitDocument = this.afs.doc(this.collection + '/' + id$);

        return this.measurementUnitDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

}
